import React, { memo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../Data/UserContext';
import { buildAuthHref, locationAuthBackPath } from '../utils/authBackPath';

const AuthenticatedRoute = memo(({ children }: { children: JSX.Element }) => {
  const { user, loading } = useUser();
  const location = useLocation();
  if (loading) {
    return <div className="app-loading-shell" aria-hidden="true" />;
  }
  if (!user) {
    const back = locationAuthBackPath(location.pathname, location.search);
    return <Navigate to={buildAuthHref("login", { back })} replace />;
  }
  return children;
});

export default AuthenticatedRoute;
